// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__3XgYS","modal":"style_modal__2rb32","closeBtn":"style_closeBtn__1I1Xg","refreshBtn":"style_refreshBtn__o_6A5"};